<template>
    <h1>{{ $t('notf.pagenotfound') }}</h1>
</template>

<script>
    export default{
        name: 'NotFound',
        data(){
            return{

            }
        },
        methods:{

        }
    }
</script>